import React from 'react';
import {Modal, ModalProps} from 'antd';
import classNames from 'classnames';
import styles from './index.module.scss';
import ModalSpin from '../ModalSpin';
import Boundary from 'Components/Boundary';

export interface FullModalProps extends Omit<ModalProps, 'width'> {}

const FullModal: React.FC<FullModalProps> = ({
    className,
    children,
    ...extraProps
}) => {
    return (
        <Modal
            className={classNames(styles.root, className)}
            centered
            {...extraProps}>
            <Boundary spinner={<ModalSpin />}>{children}</Boundary>
        </Modal>
    );
};

export default FullModal;
